import * as yup from 'yup';
import { AnyObject } from 'yup/es/types';

export const PHONE_COUNTRY = '+1';

export type ValidationProps = {
  schema: yup.StringSchema<string | undefined, AnyObject, string | undefined>;
};
